import * as PathsTypes from 'constants/PathsTypes';

export const checkCorrectUrl = (string) => {
  if (!string) return string;
  if (string.indexOf('http') === 0 || string.indexOf('static')) return string;

  return PathsTypes.SERVER_URL + string;
};
